import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { TranslateModule } from '@ngx-translate/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DestinationMatchTypeModule } from '@app/criterion-addition/shared/modules/destination-match-type/destination-match-type.module';
import { SubscriptionConfirmationComponent } from '@app/settings/shared/modules/subscription/components/confirmation/subscription-confirmation.component';
import { SubscriptionDowngradeDialogComponent } from '@app/settings/shared/modules/subscription/components/downgrade-dialog/subscription-downgrade-dialog.component';
import { PricingDetailsSelfServiceComponent } from '@app/settings/shared/modules/subscription/components/pricing-details-self-service/pricing-details-self-service.component';
import { PricingExamplesComponent } from '@app/settings/shared/modules/subscription/components/pricing-examples/pricing-examples.component';
import { PricingFeatureComparisonComponent } from '@app/settings/shared/modules/subscription/components/pricing-feature-comparison/pricing-feature-comparison.component';
import { AccordionModule } from '@app/shared/modules/accordion/accordion.module';
import { EqualSizeModule } from '@app/shared/modules/equal-size/equal-size.module';

import { SpinnerOverlayComponent } from '@app/shared/modules/spinner-overlay/spinner-overlay.component';
import { StepWizardModule } from '@app/shared/modules/step-wizard/step-wizard.module';
import { TourModule } from '@app/shared/modules/tour/tour.module';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BillingModule } from '../billing/billing.module';
import { PaymentMethodsModule } from '../payment-methods/payment-methods.module';
import { PricingDetailsComponent } from './components/pricing-details/pricing-details.component';
import { StartSubscriptionDrawerComponent } from './components/start-drawer/start-subscription-drawer.component';
import { SubscriptionSuccessComponent } from './components/success/subscription-success.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,

    NzDividerModule,

    TranslateModule,

    BillingModule,
    EqualSizeModule,
    StepWizardModule,
    PaymentMethodsModule,
    SharedDirectivesModule,
    FormsModule,
    NzSelectModule,
    ReactiveFormsModule,
    NzSwitchModule,
    NzRadioModule,
    AccordionModule,
    DestinationMatchTypeModule,
    TourModule,
    NzTabsModule,
    NzAlertModule,
    NzCheckboxModule,
    NzToolTipModule,
    SpinnerOverlayComponent,
  ],
  declarations: [
    PricingExamplesComponent,
    PricingDetailsComponent,
    PricingDetailsSelfServiceComponent,
    PricingFeatureComparisonComponent,
    StartSubscriptionDrawerComponent,
    SubscriptionDowngradeDialogComponent,
    SubscriptionConfirmationComponent,
    SubscriptionSuccessComponent,
  ],
  exports: [
    NzDrawerModule,
    BillingModule,
    EqualSizeModule,
    PaymentMethodsModule,
    PricingExamplesComponent,
    PricingDetailsComponent,
    PricingDetailsSelfServiceComponent,
    SubscriptionDowngradeDialogComponent,
    SubscriptionSuccessComponent,
  ],
})
export class SubscriptionSharedModule {}
